<template>
  <div class="EditAddCardBrand">
    <el-dialog :visible.sync="dialog" @close="close">
      <el-form v-loading="loadingPage" v-if="dialog" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent
               v-on:submit.prevent>
        <el-form-item prop="name" label="Nome">
          <el-input size="large" v-model="ruleForm.name" required></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="17">
            <el-form-item prop="ref_external_credit" label="Nome Referencia de Crédito">
              <el-input size="large" v-model="ruleForm.ref_external_credit" required></el-input>
            </el-form-item>
            <el-form-item prop="ref_external_debit" label="Nome Referencia de Débito">
              <el-input size="large" v-model="ruleForm.ref_external_debit" required></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <div v-loading="loadingUpImage">
              <label  class="el-form-item__label" style="width: 100%;text-align: left;">Logo</label>
              <el-upload
                name="image"
                style="width: 100%"
                class="avatar-uploader"
                :action="urlPostImage.url"
                :headers="urlPostImage.headers"
                :show-file-list="false"
                :auto-upload="autoUploadImage"
                :on-change="handleChange"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="urlImage" :src="urlImage" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-col>
        </el-row>
        <el-form-item prop="provider_id" label="Provedor" :error="error.code">
          <SearchProviders :model="ruleForm.provider_id" :isEdit="idConta !== ''"
                           @handleValue="(x) => {ruleForm.provider_id = x}"/>
        </el-form-item>
        <div class="boxfees">
          <el-row :gutter="20">
            <el-col :span="8">_
            </el-col>
            <el-col :span="8">
              Taxa (%)
            </el-col>
            <el-col :span="8">
              Taxa (R$)
            </el-col>
          </el-row>
          <el-row :gutter="20" v-for="(fee, i) in ruleForm.fees" :key="i">
            <el-col :span="8">
              Crédito {{fee.number_installments}}x
            </el-col>
            <el-col :span="8">
              <el-input type="number" v-model="fee.percent_amount">
                <template slot="append">%</template>
              </el-input>
            </el-col>
            <el-col :span="8">
              <div class="space_imput">
                <div class="el-input el-input--large">
                  <money class="el-input__inner" v-model="fee.amount" v-bind="money"/>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <span slot="footer" style="display: flex; align-items: center; justify-content: space-between;">
        <el-button v-if="ruleForm.id" @click.prevent="delElement">Excluir</el-button>
        <div v-else></div>
        <el-button type="primary" native-type="submit" @click.prevent="submitForm('ruleForm')">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {deleteCardBrand, getCardBrand, postCardBrand, putCardBrand} from "@/app/domains/Config/services";
import {clearRuleForm, makeErrorFilds} from "@/app/plugins/utils";
import SearchProviders from "@/app/components/Providers/SearchProviders";
import {api as configs} from "../../../../config";
import { mapGetters } from 'vuex'

export default {
  name: "dialogEditAddCardBrand",
  components: {
    SearchProviders
  },
  props: ['show', 'idConta'],
  watch: {
    'show': function (e) {
      this.dialog = e
    },
    'idConta': function (e) {
      if (e !== '') {
        // 
        this.getCardBrand(e)
      }
    }
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      loadingUpImage: false,

      dialog: false,
      loadingPage: false,
      rules: {},
      error: {},
      ruleForm: {
        fees: [
          {
            "payment_type": "debit",
            "number_installments": 1,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 2,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 3,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 4,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 5,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 6,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 7,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 8,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 9,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 10,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 11,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 12,
            "percent_amount": 0,
            "amount": 0,
          },
        ]
      },
      urlImage: '',
      rawImage: null,
      // formImage: {
      //   url: `${configs.baseUrl}logo/card_brand/${this.ruleForm.id}`,
      //   headers: {
      //     Authorization: ''
      //   }
      // },
    }
  },
  computed: {
    ...mapGetters('Auth', ['getToken']),
    autoUploadImage: function () {
      return (this.ruleForm.id) ? true : false
    },
    urlPostImage: function () {
      return {
        url: `${configs.baseUrl}import/logo/card_brand/${this.ruleForm.id}`,
        headers: {
          Authorization: 'Bearer ' + this.getToken
        }
      }
    }
  },
  methods: {
    handleChange(file) {
      
      this.loadingUpImage = true
      this.urlImage = URL.createObjectURL(file.raw);
      this.rawImage = file.raw
      // this.ruleForm.image = file.raw
      this.loadingUpImage = false
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.image = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('Avatar picture size can not exceed 2MB!');
      }
      return isLt2M;
    },
    close() {
      this.$emit('close')
      this.$refs['ruleForm'].resetFields()
      this.$refs['ruleForm'].clearValidate()
      this.ruleForm = {
        fees: [
          {
            "payment_type": "debit",
            "number_installments": 1,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 2,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 3,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 4,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 5,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 6,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 7,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 8,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 9,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 10,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 11,
            "percent_amount": 0,
            "amount": 0,
          },
          {
            "payment_type": "debit",
            "number_installments": 12,
            "percent_amount": 0,
            "amount": 0,
          },
        ]
      }
      this.urlImage = ''
      this.rawImage = null
    },
    delElement() {
      this.$confirm('Deseja excluir este Bandeira?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        center: true,
        type: 'warning'
      }).then(async () => {
        this.loadingPage = true
        this.error = {}
        try {
          let response;
          // let query = this.$route.meta.pathAPI + '/' + this.ruleForm.id
          response = await deleteCardBrand('/' + this.ruleForm.id)
          
          this.$message({
            showClose: true,
            message: 'Excluido',
            type: 'success'
          })
          this.dialog = false
          this.close()
        } catch (e) {
          this.error = makeErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {
      });
    },
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          this.loadingPage = true
          this.error = {}
          try {
            let response;
            if (this.ruleForm.id !== undefined) {
              response = await putCardBrand(clearRuleForm(this.ruleForm))
              this.$message({
                showClose: true,
                message: 'Editado com Sucesso',
                type: 'success'
              })
            } else {
              response = await postCardBrand(this.ruleForm)
              this.$message({
                showClose: true,
                message: 'Adicionado com sucesso',
                type: 'success'
              })
            }
            this.dialog = false
            this.close()
          } catch (e) {
            this.error = makeErrorFilds(e)
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }
      })
    },
    handleAction() {
    },
    async getCardBrand(id) {
      this.loadingPage = true
      try {
        let response = await getCardBrand('/' + id)
        this.ruleForm = response.data
      } catch (e) {
        
        this.$message({
          showClose: true,
          message: e.body.message,
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
